import React, { useContext, useEffect } from 'react'
import { useSections } from '@hooks/useSections'
import { groupBy } from '@helpers/utilities'
import { useFilteredItems } from '@hooks/useFilteredItems'
import Text from '@components/Text'
import Loader from '@components/Loader'
import SubjectSectionsGroup from '@components/SubjectSectionsGroup'
import { AppContext } from '@state/context'
import { USER_ROLES } from '@helpers/constants'
import { setFilteredItems } from '@state/actions/filtersActions'

const Sections = () => {
  const [state, dispatch] = useContext(AppContext)
  const userRole = state?.app?.userRole
  const {
    userCreatedSections,
    userSavedSections: sections,
    error,
    isLoading
  } = useSections()

  const filteredSections = useFilteredItems(sections)
  const filteredUserCreatedSections = useFilteredItems(userCreatedSections)

  useEffect(() => {
    dispatch(setFilteredItems([...sections, ...userCreatedSections]))
  }, [sections, userCreatedSections])

  // Grouped by subject
  const sectionsBySubject = (userRole === USER_ROLES.ADMIN ? filteredUserCreatedSections : filteredSections).reduce((acc, item) => {
    if (item.subject.id in acc) {
      acc[item.subject.id].items.push(item)
    } else {
      acc[item.subject.id] = {
        subject: item.subject,
        items: [item],
      }
    }
    return acc
  }, {})

  return (
    <div className={'flex flex-col items-center justify-center'}>
      {userRole !== USER_ROLES.ADMIN &&
        <>
          {error && <Text>Nåt gick fel när avsnitt skulle laddas</Text>}
          {!isLoading && !filteredSections.length && (
            <Text>Kunde inte hitta några avsnitt</Text>
          )}

          {Object.entries(sectionsBySubject).map(([key, group], index) => {
            return <SubjectSectionsGroup key={key} group={group} />
          })}
        </>
      }

      {userRole === USER_ROLES.ADMIN &&
        <>
          {!isLoading && !Object.entries(sectionsBySubject)?.length &&
            <Text>Kunde inte hitta några avsnitt</Text>
          }
          {Object.entries(sectionsBySubject).map(([key, group], index) => {
            return <SubjectSectionsGroup key={key} group={group} />
          })}

          {isLoading && <Loader />}
        </>
      }
    </div>
  )
}

export default Sections
